import { Grid } from '@material-ui/core'
import React, { useContext } from 'react'
import useContentFilterStyles from '../styles';
import { TutorialInfoDialog } from 'src/pages/tutorials/TutorialInfoDialog';
import { useIntl } from 'react-intl';
import useEntityList from 'src/hooks/useEntityList';
import { getVideoSourceByAppSection } from 'src/utils/getVideoSourceTutorial';
import { SectionOptions } from 'src/components/users/helpers';
import { Tutorial } from 'myfitworld-model';
import { tutorialApi } from 'src/api/common';
import UserContext from 'src/contexts/UserContext';
import componentMessages from "src/components/messages";

function ContentTutorialContainer({ entityName }: { entityName?: string }) {
  const classes = useContentFilterStyles();
  const userContext = useContext(UserContext);
  const { formatMessage } = useIntl();

  const { data: tutorials } = useEntityList<Tutorial>(tutorialApi.list);
  
  const videoSource1 = getVideoSourceByAppSection(tutorials, SectionOptions[23].id, userContext?.user?.language);
  const videoSource2 = getVideoSourceByAppSection(tutorials, SectionOptions[24].id, userContext?.user?.language);
  const videoSource3 = getVideoSourceByAppSection(tutorials, SectionOptions[25].id, userContext?.user?.language);
  const videoSource4 = getVideoSourceByAppSection(tutorials, SectionOptions[26].id, userContext?.user?.language);
  const videoSource5 = getVideoSourceByAppSection(tutorials, SectionOptions[27].id, userContext?.user?.language);
  const videoSource6 = getVideoSourceByAppSection(tutorials, SectionOptions[28].id, userContext?.user?.language);

  const videoSource: any =
    entityName === 'Exercise' ? videoSource1 :
      entityName === 'Workout' ? videoSource2 :
        entityName === 'Program' ? videoSource3 :
          entityName === 'Grocery' ? videoSource4 :
            entityName === 'Meal' ? videoSource5 :
              entityName === 'NutritionPlan' ? videoSource6 :
                undefined;

  const tutorialTitle =
    entityName === 'Exercise' ? formatMessage(componentMessages.editExercise) :
      entityName === 'Workout' ? formatMessage(componentMessages.editWorkout) :
        entityName === 'Program' ? formatMessage(componentMessages.editProgram) :
          entityName === 'Grocery' ? formatMessage(componentMessages.editGrocery) :
            entityName === 'Meal' ? formatMessage(componentMessages.editMeal) :
              entityName === 'NutritionPlan' ? formatMessage(componentMessages.editNutritionPlan) :
                "";
  return (
    <Grid item className={classes.tutorialIconStyle}>
      <TutorialInfoDialog title={tutorialTitle} videoSource={videoSource} />
    </Grid>)
}

export default ContentTutorialContainer
